


























































































































































import Vue from "vue";
import Component from "vue-class-component";
import { Getter, Action } from "vuex-class";
import { Watch } from "vue-property-decorator";

import Customer from "@/types/customer/Customer";
import UserInterface from "@/types/app/IUser";

import VuetifySelectItems from "@/types/app/vuetifySelectItems";
import Investment from "@/types/app/investment";
import ModalSuccess from "@/components/common/ModalSuccess.vue";
import compareTo from "@/utils/compareTo";
import getCustomers, { CustomerSelectValue } from "@/utils/getCustomers";
import formatMoney from "@/utils/formatMoney";
import formatDate from "@/utils/formatDate";
import Endpoint from "@/utils/endpoint";
import { warn } from "vue-class-component/lib/util";
import NotificationInterface, {
  notificationInitialValue,
} from "@/types/app/notifications";
import AccountInterface from "@/types/app/accounts";
import ErrorService from "@/services/erroService";
import BaseComponent from "@/utils/baseComponent";
import WalletService from "@/services/walletService";
import { VueEditor } from "vue2-editor";
import CustomerService from "@/services/customerService";
import ProductService from "@/services/productService";
// import SelectProduct from "@/components/common/SelectProducts.vue";
import product from "@/store/modules/product";
import AccountService from "@/services/accountService";
import TemplateEmailDocument from "@/utils/templateEmailDocuments";
import ProductFund from "@/types/app/productFunds";
const namespace = "communication";

interface NotificationType {
  id: string;
  title: string;
}


const asyncFilter = async (arr: any[], predicate: any) =>
  Promise.all(arr.map(predicate)).then((results) =>
    arr.filter((_v, index) => results[index])
  );

@Component({
  components: { ModalSuccess, VueEditor },
  data: () => ({
    formType: "",
    notification: notificationInitialValue,
    required: (v: any) => !!v || "This field is required",
    inputRule: [(v: any) => v.length >= 1 || "Please select a customer"],
    urlRules: [
      (v: any) => !!v || "URL is required",
      (v: any) =>
        (v && v.length <= 256) ||
        "URL must be less than 256 characters" /* eslint-disable-next-line no-useless-escape*/,
      (v: any /* eslint-disable-next-line no-useless-escape*/) =>
        /https?:[0-9]*\/\/[\w!?/\+\-_~=;\.,*&@#$%\(\)\'\[\]]+/.test(
          v
        ) /* eslint-disable-next-line no-useless-escape*/ || "URL must be valid",
    ],
  }),
})
export default class NotificationEmailCreate extends BaseComponent {
  @Getter("getModalNewEmailNotificationState", { namespace })
  modalNewEmailNotificationState!: boolean;

  @Action("setModalNewEmailNotificationState", { namespace })
  setModalNewEmailNotificationState!: any;
  @Action("setModalEmailNotificationDeleteState", { namespace })
  setModalEmailNotificationDeleteState!: any;

  accounts: AccountInterface[] = [];
  @Getter("getLoading", { namespace }) loading!: boolean;
  @Getter("getEmailNotificationSent", { namespace }) emailNotificationSent!: boolean;
  @Getter("getEmailNotificationState", { namespace })
  emailNotificationEdit!: NotificationInterface;

  @Action("setLoading", { namespace }) setLoading!: any;

  @Action("setEmailNotificationSent", { namespace })
  setEmailNotificationSent!: any;

  private endpoint = new Endpoint();

  items: VuetifySelectItems[] = [];

  customersNotification: any[] = [];
  filteredCustomers: VuetifySelectItems[] = [];
  selectedInvestors: any[] = [];
  disableCustomers: any[] = [];
  walletService = new WalletService(this.$http);
  customerService = new CustomerService(this.$http);
  productService = new ProductService(this.$http);
  accountService = new AccountService(this.$http);
  products: VuetifySelectItems[] = [];
  funds: VuetifySelectItems[] = [];
  openSuccessModal = false;
  openSuccessModalMessage = "";
  notification: NotificationInterface = notificationInitialValue;
  documents: VuetifySelectItems[] = TemplateEmailDocument.CategoryDocuments;
  
  notificationData = {
    pageApp: Number(1),
    productId: String(),
    product: { value: String(), text: String() },
    fund: { value: String(), text: String(), fundName: String() },
    fundId: String(),
    emailTag: { value: String(), text: String() },
  };

  customToolbar = [
    [{ font: [] }],
    [{ header: [false, 1, 2, 3, 4, 5, 6] }],
    [{ size: ["small", false, "large", "huge"] }],
    ["bold", "italic", "underline", "strike"],
    [{ align: "" }, { align: "center" }, { align: "right" }, { align: "justify" }],
    [{ header: 1 }, { header: 2 }],
    ["blockquote"],
    [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
    [{ indent: "-1" }, { indent: "+1" }],
    [{ color: [] }, { background: [] }],
    ["link"],
    ["clean"],
  ];

  formatDate = formatDate;
  formatMoney = formatMoney;
  formType = "new";
  urlRules = {};
  inputRule = {};
  notificationLoading = false;

  showConfirmDelete(): void {
    this.setModalNewEmailNotificationState(false);
    this.setModalEmailNotificationDeleteState(true);
  }

  @Watch("emailNotificationEdit")
  async loadNotification() {
    //to work with changes in someOtherProp
    if (this.emailNotificationEdit.id) {
      this.formType = "view";
      this.notification = this.emailNotificationEdit;
      this.filteredCustomers = this.customersNotification.filter(
        (x: VuetifySelectItems) =>
          this.emailNotificationEdit.usersId.some((y) => y == x.value)
      );
      this.selectedInvestors = this.emailNotificationEdit.usersId;
      this.filteredCustomers.forEach((x: VuetifySelectItems) => (x.disabled = true));
    } else {
      this.formType = "new";
      this.filteredCustomers = [];
      this.filteredCustomers = this.customersNotification;
      this.filteredCustomers.forEach((x: VuetifySelectItems) => (x.disabled = false));
      this.disableCustomers = [];
    }
  }

  async mounted() {
    const [fundResponse, productResponse, _, __] = await Promise.all([
      this.walletService.getProductFunds(),
      this.productService.getProducts(),
      this.getCustomersAll(),
      this.getAccounts()
    ]);
    this.funds = fundResponse;
    this.products = productResponse;
  }

  get likesAllCustomer() {
    return this.selectedInvestors.length === this.filteredCustomers.length;
  }

  get likesSomeCustomers() {
    return this.selectedInvestors.length > 0 && !this.likesAllCustomer;
  }
  get icon() {
    if (this.likesAllCustomer) return "mdi-close-box";
    if (this.likesSomeCustomers) return "mdi-minus-box";
    return "mdi-checkbox-blank-outline";
  }

  chkClearCustomers() {
    this.selectedInvestors = [];
    this.filteredCustomers = this.customersNotification;
    this.notificationData.productId = "";
    this.notificationData.fundId = "";
    this.notificationData.product = { value: "", text: "" };
    this.notificationData.fund = { value: "", text: "", fundName: "" };
  }

  toggleSelectAll() {
    this.$nextTick(() => {
      if (this.likesAllCustomer) {
        this.selectedInvestors = [];
      } else {
        this.selectedInvestors = this.filteredCustomers;
      }
    });
  }

  async checkCustomerHasAccount(userId: string) {
    return this.accounts.some((x) => x.userId === userId);
  }

  onChangeCategory(category: VuetifySelectItems) {
    this.notification.body = ''
    if (category.value == 'Capital Call')
      this.notification.body = TemplateEmailDocument.CapitalCall;
    else if (category.value == 'Distribution')
      this.notification.body = TemplateEmailDocument.DistributionNotices;
    else if (category.value == 'NAV Statement')
      this.notification.body = TemplateEmailDocument.NavStatement;
  }

  async onChangeFund(fund: VuetifySelectItems) {
    console.log('fire:onChangeProduct', fund);
    this.notificationData.productId = fund.value;
    this.selectedInvestors = [];
    this.filteredCustomers = this.customersNotification.filter((item) =>
      this.accounts.some((x) => x.userId == item.value && x.fundId == fund.value)
    );
  }

  async onChangeProduct(product: VuetifySelectItems) {
    this.notificationData.productId = product.value;
    if (product.data.is506c) {
      this.selectedInvestors = [];
      this.filteredCustomers = this.customersNotification.filter(
        (item) =>
          item.data.hasAccount ||
          (item.data.scheduleIndexResponse &&
            item.data.scheduleIndexResponse.status === "Done")
      );
    }
  }

  async sendNotificationEmail() {
    console.log(this.selectedInvestors);
    if (this.form().validate()) {
      try {
        if (this.notificationLoading)
          return;
        this.notificationLoading = true;

        if (this.selectedInvestors.length == 0) {
          this.openSuccessModalMessage =
            "Select at least one customer to send the notification";
          this.openSuccessModal = true;
          this.notificationLoading = false;
        } else if (this.selectedInvestors.length > 0) {
          this.notification.usersId = this.selectedInvestors.filter(i => i.group == 'Clients').map((item) => item.value);
          this.notification.investorIds = this.selectedInvestors.filter(i => i.group != 'Clients').map((item) => item.value);
          await this.sendNotification();
          this.notificationLoading = false;
        }
      } catch (error) {
        ErrorService.onError({
          status: -1,
          message: "Notifications:New:MakeANewNotification",
          error,
        });
      }
    }
  }

  async sendNotification() {
    await this.$confirm("Do you really want to save an email notification?").then(
      async (res) => {
        this.notificationLoading = true;
        if (res) {
          const url = `${this.endpoint.notifications}/send-email`;
          await this.$http
            .post(url, {
              notSendEmail: true,
              pageRequest: this.notificationData.pageApp,
              title: this.notification.title,
              subject: this.notification.description,
              body: `${this.notification.body}`,
              usersId: this.notification.usersId,
              investorIds: this.notification.investorIds,
              fundName:
                this.notificationData.pageApp == 4 || this.notificationData.pageApp == 2
                  ? this.notificationData.fund.text
                  : "",
              productName:
                this.notificationData.pageApp == 3
                  ? this.notificationData.product.text
                  : "",
              pageId:
                this.notificationData.pageApp == 2 || this.notificationData.pageApp == 4
                  ? this.notificationData.fund.value
                  : this.notificationData.pageApp == 3
                    ? this.notificationData.product.value
                    : "",
              tag:
                this.notificationData.pageApp == 4
                  ? this.notificationData.emailTag.value
                  : "",
            })
            .then((res: any) => {
              this.showNotificationSentModal();
              this.clearFields();
              this.closeModal();
            })
            .catch((error) => {
              ErrorService.onError({
                status: -1,
                message: "Notifications:New:SendEmailNotification",
                error,
              });
            })
            .finally(() => {
              this.notificationLoading = false;
            });
        } else this.notificationLoading = false;
      }
    );
  }

  async getAccounts() {
    try {
      const [newAccounts] = await Promise.all([this.accountService.getAccounts()])
      this.accounts = newAccounts;
    } catch (error) {
      ErrorService.onError(error);
    }
  }

  closeModal(): void {
    this.clearFields();
    this.$router.push({ name: 'E-mail' });
  }

  showNotificationSentModal() {
    this.openSuccessModalMessage = "Notification email saved with success!!";
    this.openSuccessModal = true;
  }

  clearFields() {
    this.notification = notificationInitialValue;
    this.notification.title = "";
    this.notification.description = "";
    this.notification.body = "";
    this.notificationData = {
      pageApp: 1,
      productId: "",
      product: { value: "", text: "" },
      fund: { value: "", text: "", fundName: "" },
      fundId: "",
      emailTag: { value: "", text: "" },
    };
    this.chkClearCustomers();
  }

  async getProductFunds(): Promise<VuetifySelectItems[]> {
    const url = this.endpoint.productFund;
    const response = await this.$http.get(`${url}?hasInvestment=true`);
    const productFunds = response.data as ProductFund[];
    const productFundsOrdened = productFunds.sort((a, b) =>
      compareTo(a.fundSiteName, b.fundSiteName)
    );

    const itemsForVuetifySelect = productFundsOrdened.map((productFund) => ({
      text: productFund.fundSiteName,
      value: productFund.fundId,
      data: productFund,
    }));

    return itemsForVuetifySelect;
  }

  async getCustomersAll(): Promise<void> {

    const customersAccount = await this.customerService.getSelectAccountCustomers();

    this.customersNotification.push({ header: 'Clients' });
    customersAccount.filter(x => x.group == 'Clients').forEach(element => {
      this.customersNotification.push(element);
    });
    this.customersNotification.push({ divider: true });

    const groups = customersAccount.filter(x => x.group != 'Clients').map(item => item.group)
      .filter((value, index, self) => self.indexOf(value) === index)

    groups.forEach(group => {
      this.customersNotification.push({ header: group });
      customersAccount.filter(x => x.group == group).forEach(customer => {
        this.customersNotification.push(customer);
      })
      this.customersNotification.push({ divider: true });
    });
    this.filteredCustomers = this.customersNotification;
  }
}
